import React from 'react';
import { componentService } from 'js/services/component.service';

export const SLIDE_MENU_CLASS_NAME = 'fn-slide-menu-container';

export const SlideMenu = () => (
    <div className={`${SLIDE_MENU_CLASS_NAME} cms-slide-menu-container`} />
);

componentService.registerWebContentComponents({ SlideMenu });
